import { Auth } from 'aws-amplify';
import EventBus from '@/utils/EventBus';
import store from '@/store';

async function logout() {
  Auth.signOut()
    .then(() => {
      store.commit('reset');
      EventBus.$emit('authState', 'SIGNED_OUT');
    })
    .catch((err) => {
      const error = err.message || err;
      console.error(error);
    });
}

export default logout;
